const Loader = (props) => {
  return (
    <div className="SiteLoader" id="loader">
      <div className={`spinner ${props.className || ""}`}>
        <div className="bounce1"></div>
        <div className="bounce2"></div>
        <div className="bounce3"></div>
      </div>
    </div>
  );
};

export default Loader;
